import React, { useEffect, useState } from 'react';
import { supabase } from './supabase';

// Photos and signatures live in the private "inventory" bucket. Rows store the
// object path; older rows store a public URL, which is converted to its path.
const BUCKET = 'inventory';
const LEGACY_MARKER = `/storage/v1/object/public/${BUCKET}/`;
const SIGNED_URL_SECONDS = 300;

export const toStoragePath = (value) => {
  if (!value || typeof value !== 'string') return null;
  const i = value.indexOf(LEGACY_MARKER);
  if (i !== -1) return decodeURIComponent(value.slice(i + LEGACY_MARKER.length).split('?')[0]);
  if (/^(https?:|data:|blob:)/i.test(value)) return null;
  return value.replace(/^\/+/, '');
};

export const getSignedStorageUrl = async (value) => {
  const path = toStoragePath(value);
  if (!path) return null;
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, SIGNED_URL_SECONDS);
  if (error) {
    console.error('Could not sign storage URL:', error.message);
    return null;
  }
  return data.signedUrl;
};

// "View" link: signs when clicked, so a long table does not sign every row.
export const StorageLink = ({ value, children, style }) => (
  <a
    href="#view"
    style={style}
    onClick={async (e) => {
      e.preventDefault();
      // Open synchronously so the popup blocker allows it, then navigate.
      const win = window.open('', '_blank');
      const url = await getSignedStorageUrl(value);
      if (!win) return;
      if (!url) {
        win.close();
        alert('This file is not available.');
        return;
      }
      win.opener = null;
      win.location.href = url;
    }}
  >
    {children}
  </a>
);

export const SignedImage = ({ value, alt, style }) => {
  const [url, setUrl] = useState(undefined);
  useEffect(() => {
    let active = true;
    setUrl(undefined);
    getSignedStorageUrl(value).then((u) => { if (active) setUrl(u); });
    return () => { active = false; };
  }, [value]);
  if (url === undefined) return <span style={{ color: '#6c757d', fontSize: '12px' }}>Loading…</span>;
  if (!url) return <span style={{ color: '#6c757d', fontSize: '12px' }}>Not available</span>;
  return <img src={url} alt={alt} style={style} />;
};
